import React, { memo } from "react";
import { NavLink, withRouter } from "react-router-dom";
import PropTypes from "prop-types";

const CustomerRow = memo(({ customer, match }) => {
	return (
		<tr key={customer.uuid}>
			<td>{customer.firstName}</td>
			<td>{customer.lastName}</td>
			<td>{customer.email}</td>
			<td>{customer.toyotaID}</td>
			<td className="width-150-px">
				<NavLink to={`${match.url}/${customer.uuid}`}>
					<button className="btn btn-small pull-right button-spacing-left-10">
						<span className="icon-spacing-right-8 glyphicon glyphicon-search" aria-hidden="true" />
						{` `}
						View details
					</button>
				</NavLink>
			</td>
		</tr>
	);
});
CustomerRow.displayName = `CustomerRow`;
CustomerRow.propTypes = {
	customer: PropTypes.object.isRequired,
	match: PropTypes.object.isRequired
};

export default withRouter(CustomerRow);
